import React, { useState } from "react";
import { LoadingOverlay } from "@mantine/core";

import { useEmployerReport } from "../providers/EmployerReportProvider";

const EmployerReportContainer: React.FC = () => {
  const { metabaseDashboardUrl } = useEmployerReport();
  const [loading, setLoading] = useState(true);

  return (
    <div
      className="m-8 h-full"
      style={{
        height: "100vh",
      }}
    >
      <LoadingOverlay visible={loading} />
      {metabaseDashboardUrl && (
        <iframe
          title="Metabase Reports"
          src={metabaseDashboardUrl}
          onLoad={() => setLoading(false)}
          width="100%"
          height="100%"
          style={{
            backgroundColor: "transparent",
          }}
        />
      )}
    </div>
  );
};

export default EmployerReportContainer;
